import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { EachWayPlaceTerms } from '@swf/sports/components';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionList from '../../components/SelectionList/SelectionList';
import useMarketDisplayLimit from '../../hooks/useMarketDisplayLimit';

import styles from './NamedList.scss';

const NamedList: MarketTemplateComponent<
  SingleMarketTemplateProps & {
    showPreviousPrice?: true;
  }
> = ({ marketId, showPreviousPrice }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));

  const { runners = [], marketName, placeTerms } = market ?? {};

  const [runnersToDisplay, handleShowMoreClick, limitRunners] = useMarketDisplayLimit(
    runners,
    marketId
  );

  if (!market) return null;
  return (
    <SelectionList
      as="dl"
      data-testid="market-template-named-list"
      className={styles.wrapper}
      market={market}
    >
      {marketName && (
        <SelectionList.Title data-testid="market-template-named-list-title">
          {marketName}
          <EachWayPlaceTerms placeTerms={placeTerms} className={styles.eachWay} />
        </SelectionList.Title>
      )}
      {runnersToDisplay.map((runner) => (
        <SelectionList.Item
          key={runner.selectionId}
          runner={runner}
          showPreviousPrice={showPreviousPrice}
        />
      ))}
      {limitRunners && <SelectionList.ShowMoreButton onClick={handleShowMoreClick} />}
    </SelectionList>
  );
};

NamedList.marketTemplateType = 'BASE';

export default NamedList;
